export default "__VITE_ASSET__fca001bc__"